import request from '@/services/interceptor.js'


export const login_auth = par => {
  return request({
    url: '/auth/login',
    method: 'post',
    data: par
  })
}
export const logout_auth = () => {
  return request({
    url: '/auth/logout',
    method: 'get'
  })
}

/* export const get_download_page = () => {
  return request({
    url: '/auth/download/page',
    method: 'get'
  })
} */

export const get_admin_page = () => {
  return request({
    url: '/auth/admin/page',
    method: 'get'
  })
}

export const get_configuratore_page = () => {
  return request({
    url: '/auth/configuratore/page',
    method: 'get'
  })
}

export const get_ext_page = (page) => {
  return request({
    url: '/auth/' + page + '/page',
    method: 'get'
  })
}